export function TH01Mark(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 237 324"
      {...props}
    >
      <path
        fill="currentColor"
        d="M50.3758 149V25H0.787888V0.206055H124.788V25H75.1697V149H50.3758ZM137.212 149V0.206055H162.006V49.8242H211.594V0.206055H236.388V149H211.594V74.6182H162.006V149H137.212ZM76.3976 299.206V200H26.8097V299.206H76.3976ZM2.01578 324V175.206H101.192V324H2.01578ZM210.336 324V175.206H235.13V324H210.336Z"
      />
    </svg>
  );
}

export function getMarkSVG(color: string) {
  return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 237 324"><path fill="${color}" d="M50.3758 149V25H0.787888V0.206055H124.788V25H75.1697V149H50.3758ZM137.212 149V0.206055H162.006V49.8242H211.594V0.206055H236.388V149H211.594V74.6182H162.006V149H137.212ZM76.3976 299.206V200H26.8097V299.206H76.3976ZM2.01578 324V175.206H101.192V324H2.01578ZM210.336 324V175.206H235.13V324H210.336Z"/></svg>`;
}
